import { useMemo } from 'react';
import { type SecurityEvent } from '@/mocks/saSecurity';

interface Props {
  events: SecurityEvent[];
}

export default function SecurityStatsBar({ events }: Props) {
  const stats = useMemo(() => {
    const safe = Array.isArray(events) ? events : [];
    return {
      total: safe.length,
      critical: safe.filter((e) => e.riskLevel === 'critical').length,
      high: safe.filter((e) => e.riskLevel === 'high').length,
      medium: safe.filter((e) => e.riskLevel === 'medium').length,
      low: safe.filter((e) => e.riskLevel === 'low').length,
      unresolved: safe.filter((e) => !e.resolved).length,
      logins: safe.filter((e) => e.type === 'login').length,
      failed: safe.filter((e) => e.type === 'failed_login').length,
    };
  }, [events]);

  const items = [
    { label: 'Total Eventos', value: stats.total, icon: 'ri-shield-line', color: 'bg-slate-100 text-slate-600' },
    { label: 'Críticos', value: stats.critical, icon: 'ri-alert-fill', color: 'bg-red-100 text-red-600' },
    { label: 'Alto Riesgo', value: stats.high, icon: 'ri-error-warning-line', color: 'bg-orange-100 text-orange-600' },
    { label: 'Medio Riesgo', value: stats.medium, icon: 'ri-information-line', color: 'bg-amber-100 text-amber-600' },
    { label: 'Sin Resolver', value: stats.unresolved, icon: 'ri-time-line', color: 'bg-fuchsia-100 text-fuchsia-600' },
    { label: 'Inicios Sesión', value: stats.logins, icon: 'ri-login-box-line', color: 'bg-emerald-100 text-emerald-600' },
    { label: 'Fallos Login', value: stats.failed, icon: 'ri-close-circle-line', color: 'bg-rose-100 text-rose-600' },
  ];

  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-7 gap-2">
      {items.map((item) => (
        <div
          key={item.label}
          className="bg-background-50 border border-background-200 rounded-xl p-3 flex items-center gap-3"
        >
          <div className={`w-9 h-9 rounded-lg flex items-center justify-center shrink-0 ${item.color}`}>
            <i className={`${item.icon} text-sm`}></i>
          </div>
          <div className="min-w-0">
            <p className="text-foreground-400 text-[10px] font-medium leading-tight">{item.label}</p>
            <p className="text-foreground-950 text-sm font-bold">{item.value}</p>
          </div>
        </div>
      ))}
    </div>
  );
}